import { TransactionErrorContainerDto } from './TransactionErrorContainerDto';

export class TransactionResultDto<T> {
  success?: boolean;

  model?: T;

  errors?: TransactionErrorContainerDto;
}
